import { apiClient } from '@/core/api/client';
import type { FpQaResourceBundle } from '@/shared/components/navigator-results';
import type { SharedCarePlanDetail } from '../types/shared-care-plan.types';

/**
 * Fetch a care plan an FP shared with the authenticated Care Seeker. The backend
 * authorizes via the care_plans share pointer and returns the live engagement,
 * so the in-app view always reflects the latest version.
 */
export async function getSharedCarePlan(engagementId: string): Promise<SharedCarePlanDetail> {
  const res = await apiClient.get<SharedCarePlanDetail>(`/care-plans/shared/${engagementId}`);
  return res.data;
}

/**
 * Feature 078: Key Resources for a shared care guide — the SAME resource bundle
 * the FP (and the PDF) use, behind the careseeker-authorized shared-plan endpoint.
 */
export async function getSharedCareGuideHubResources(
  engagementId: string,
): Promise<FpQaResourceBundle> {
  const res = await apiClient.get<FpQaResourceBundle>(
    `/care-plans/shared/${engagementId}/hub-resources`,
  );
  return {
    specialtyResourcesBySpecialtyId: res.data?.specialtyResourcesBySpecialtyId ?? {},
    careStageResources: res.data?.careStageResources ?? [],
  };
}
